export function isApple() {
  var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return /iPad|iPod|iPhone|Makintosh|OS X/.test(userAgent);
}